<ng-container *transloco="let t">
  <ld-base-modal
    [title]="title()"
    [size]="size()"
    [showCloseButton]="showCloseButton()"
    [isLoading]="isLoading()"
    [closeOnBackdropClick]="closeOnBackdropClick()"
    [ariaLabelledBy]="'confirmation-modal-title'"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <p id="confirmation-modal-message" class="text-ld-neutral-600">
        {{ message() }}
      </p>
    </div>

    <div modal-footer>
      @if (cancelText()) {
        <button
          id="confirmation-modal-cancel-button"
          type="button"
          class="btn-outline-ld-purple"
          style="order: 1"
          [disabled]="isLoading()"
          (click)="onCancel()"
        >
          {{ cancelText() }}
        </button>
      }
      <button
        id="confirmation-modal-confirm-button"
        type="button"
        [class]="isDestructive() ? 'btn-solid-red' : 'btn-primary-ld-purple'"
        style="order: 0"
        [disabled]="isLoading()"
        (click)="onConfirm()"
      >
        @if (isLoading()) {
          <span class="flex items-center justify-center gap-2">
            <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-white!"></mat-spinner>
            {{ confirmText() }}
          </span>
        } @else {
          {{ confirmText() }}
        }
      </button>
    </div>
  </ld-base-modal>
</ng-container>
